
export default function About() {
  const features = [
    { icon: 'ri-code-s-line', label: 'Swift Expertise' },
    { icon: 'ri-shield-check-line', label: 'Security Focus' },
    { icon: 'ri-speed-line', label: 'Performance' },
    { icon: 'ri-user-heart-line', label: 'User Experience' },
    { icon: 'ri-app-store-line', label: 'App Store' }
  ];

  return (
    <section id="about" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-[2px] text-gray-500 mb-8 font-light">
            WHO WE ARE
          </p>
          
          <div className="space-y-2">
            <h2 className="text-6xl font-normal text-gray-900 font-serif">
              Experts in iOS
            </h2>
            <h2 className="text-7xl italic text-gray-900 font-serif" style={{ marginLeft: '40px' }}>
              Development
            </h2>
            <h2 className="text-6xl font-normal text-gray-900 font-serif">
              & Innovation
            </h2>
          </div>
        </div>

        <div className="flex justify-center gap-8 flex-wrap">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-900 rounded-3xl p-6 flex items-center space-x-4 w-44 h-24 transition-transform hover:scale-105 cursor-pointer"
              style={{ boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.3)' }}
            >
              <i className={`${feature.icon} text-3xl text-white`}></i>
              <span className="text-white text-base font-light">{feature.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}